import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=386d5d08"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"
import style0 from "./Summary.vue?vue&type=style&index=0&id=386d5d08&prod&lang=css"
import style1 from "./Summary.vue?vue&type=style&index=1&id=386d5d08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports